import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Login from './pages/Login';
import Activate from './pages/Activate';
import SetPassword from './pages/SetPassword';
import Dashboard from './pages/Dashboard';
// StatusCenter removed — merged into CommandCenter
import FeeOverride from './pages/FeeOverride';
import CreateApplication from './pages/CreateApplication';
import GatewaySession from './pages/GatewaySession';
import CommandCenter from './pages/CommandCenter';
import './styles/global.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes - redirect to dashboard if logged in */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/activate"
            element={
              <PublicRoute>
                <Activate />
              </PublicRoute>
            }
          />
          <Route
            path="/set-password"
            element={
              <PublicRoute>
                <SetPassword />
              </PublicRoute>
            }
          />

          {/* Protected routes - redirect to login if not logged in */}
          <Route
            path="/command-center"
            element={
              <ProtectedRoute>
                <CommandCenter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/status-center"
            element={<Navigate to="/command-center" replace />}
          />
          <Route
            path="/create-application"
            element={
              <ProtectedRoute>
                <CreateApplication />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fee-override"
            element={
              <ProtectedRoute>
                <FeeOverride />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gateway/:applicationId"
            element={
              <ProtectedRoute>
                <GatewaySession />
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/command-center" replace />} />
          <Route path="*" element={<Navigate to="/command-center" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
